import { z } from 'zod';

export const SearchResultClientZod = z.object({ participantId: z.number(), fullName: z.string(), email: z.string() });
export type SearchResultClient = z.infer<typeof SearchResultClientZod>;
